/**
 * Created by olga on 12.12.2025
 */

const AutoPlay = function () {
};

AutoPlay.prototype.start = function (ingredients) {
    this.isRunning = true;

    cleverapps.eventBus.on("order_ready_changed", () => {
        this.stop();
    }, this);

    this.setSingleCustomerMarks();

    Merge2.current.field.on("onUnitAvailable", (unit) => {
        if (this.requiredUnits[Unit.GetKey(unit)]) {
            unit.singleCustomerMark = true;
            this.requiredUnits[Unit.GetKey(unit)]--;
        }
    });

    const actions = [
        () => this.autoMerge(true),
        () => this.autoMerge(),
        this.autoGenerate
    ];

    while (this.isRunning) {
        let count = 0;
        actions.forEach((action) => {
            if (this.isRunning) {
                const lacking = Merge2.current.stock.getLackingUnits(ingredients);
                if (action(lacking)) {
                    count++;
                }
                action(lacking);
            }
        });
        if (count === 0) {
            this.stop();
        }
    }
};

AutoPlay.prototype.setSingleCustomerMarks = function () {
    this.requiredUnits = {};

    Merge2.current.customers.listCustomersWithRecipe().forEach((customer) => {
        customer.getCurrentRecipe().getIngredients().forEach((ingredient) => {
            if (ingredient.unit) {
                this.requiredUnits[Unit.GetKey(ingredient.unit)] = this.requiredUnits[Unit.GetKey(ingredient.unit)] || 0;
                this.requiredUnits[Unit.GetKey(ingredient.unit)]++;
            }
        });
    });

    Merge2.current.field.listAvailableUnits((unit) => {
        if (this.requiredUnits[Unit.GetKey(unit)] && !unit.isGrounded()) {
            unit.singleCustomerMark = true;
            this.requiredUnits[Unit.GetKey(unit)]--;
        }
    });
};

AutoPlay.prototype.resetSingleCustomerMarks = function () {
    this.requiredUnits = {};

    Merge2.current.field.listAvailableUnits((unit) => {
        delete unit.singleCustomerMark;
    });
};

AutoPlay.prototype.stop = function () {
    if (this.isRunning) {
        runCleaners(this);
        this.isRunning = false;
        this.resetSingleCustomerMarks();
    }
};

AutoPlay.prototype.autoMerge = function (grounded) {
    let count = 0;
    while (this.isRunning) {
        if (cleverapps.focusManager.isFocused()) {
            cleverapps.notification.create("Auto play stopped by focus!");
            break;
        }
        const toMerge = MergeHintLogics.collectCandidates(grounded, {
            mark: "singleCustomerMark"
        });
        if (toMerge.length === 0) {
            break;
        }

        const first = toMerge[0].unit;
        const cells = toMerge[0].cells;
        const second = Merge2.current.field.getUnit(cells[cells.length - 1].x, cells[cells.length - 1].y);
        const mergeComponent = first.findComponent(MergeComponent);
        mergeComponent.merge([second]);
        Merge2.current.counter.trigger();
        count++;
    }

    return count > 0;
};

AutoPlay.prototype.autoGenerate = function (units) {
    if (cleverapps.focusManager.isFocused()) {
        cleverapps.notification.create("Auto play stopped by focus!");
        return false;
    }

    if (cleverapps.lives.isEmpty()) {
        cleverapps.notification.create("Auto play stopped by energy!");
        return false;
    }

    if (Merge2.current.field.countEmptySlots() === 0) {
        cleverapps.notification.create("Auto play stopped by no spase!");
        return false;
    }
    const generators = Merge2.current.field.listAvailableUnits({ type: "generator" }).map((unit) => unit.findComponent(Merge2Generator));
    const generator = generators.find((g) => {
        if (!g || !g.canStartMine()) {
            return false;
        }
        const config = OrdersAlgoConfig.generators[g.unit.code];
        let drop = config.stages[g.unit.stage].drop;
        const overrideDrop = config.algorithm && config.algorithm.overrideDrop;
        if (overrideDrop) {
            drop = drop.concat(overrideDrop);
        }
        return cleverapps.intersect(drop, units.map((u) => u.code)).length;
    });

    if (!generator) {
        cleverapps.notification.create("Auto play stopped by generator completion!");
        return false;
    }

    return generator.startMine();
};